import * as React from "react";
import { useBloomreachPageModels } from "./use-bloomreach-page-models.js";
import { useBloomreachPageName } from "./use-bloomreach-page-name.js";
function useBloomreachProductRoutes() {
  const pageModels = useBloomreachPageModels();
  const pageName = useBloomreachPageName();
  const productRoutes = pageModels?.productRoutes ?? {};
  const hasRoutes = Object.keys(productRoutes).length > 0;
  if (!hasRoutes) {
    console.log(
      `Could not get productRoutes for page with name ${pageName}, got: ${JSON.stringify(
        productRoutes
      )}`
    );
  }
  const { $ref, ...routes } = productRoutes;
  return React.useMemo(() => [{ hasRoutes }, routes], [hasRoutes, routes]);
}
export {
  useBloomreachProductRoutes
};
//# sourceMappingURL=use-bloomreach-product-routes.js.map
